import { createGraphQLClient } from '@dvag/dfs-api-client';
import { getEnvironmentApiUrls } from '@dvag/dfs-constant-config/api-urls';
import { getContext, getToken } from '@dvag/dfs-orchestrator-client';
import { GraphQLClient } from 'graphql-request';

export const getHeaders = (etag?: string | null) => {
  const user = getContext()?.user;

  return {
    ...(user?.parentUserId ? { 'parent-user-id': user.parentUserId } : {}),
    ...(etag ? { 'If-Match': etag } : {}),
  };
};

type GraphQLClientEndpoints = ReturnType<typeof getEnvironmentApiUrls>['graphQl'];

export const getGraphQLClient = (
  service: keyof GraphQLClientEndpoints = 'person',
  etag?: string | null,
) => {
  const url = getEnvironmentApiUrls().graphQl[service];
  return createGraphQLClient({
    createClient: (requestMiddleware) =>
      new GraphQLClient(url, {
        credentials: 'include',
        requestMiddleware,
      }),
    getAdditionalHeaders: () => getHeaders(etag),
    getToken,
  });
};
